import { useEffect } from "react";
import { toast } from "react-toastify";
import { NavigateFunction, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useDispatch } from "react-redux";

import LandingWrapper from "../../StylesWrappers/LandingPage/landingWrapper";
import Logo from "../../components/General/Logo";
import TitleText from "../../components/General/Helmet";
import { staticImage } from "../../assets/images/images";
import { getToken } from "../../utils/tokenStorage";
import { toastMessage } from "../../utils/toastMessage";
import { AppDispatch } from "../../store";

const LandingPage = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const token = getToken();

  // Navigate to the dashboard if token is still available in the local storage
  useEffect(() => {
    if (token) {
      navigate("/dashboard");
      toastMessage(
        "Token valid! Hence you're logged in",
        dispatch,
        toast.success
      );
    }
  }, [dispatch, navigate, token]);

  return (
    <LandingWrapper>
      <TitleText
        title="Jobtrackier - Your Job, Your Dream | #1 Software Product for Tracking Jobs
      Applied for"
      />
      <div className="logo__con">
        <Logo />
      </div>
      <div className="summary__con">
        <summary>
          <section className="landing__content__and__img">
            <div className="landing__content">
              <p>
                Take <span>Charge</span> of your <span>Applications</span>!
              </p>
              <p>
                Your personalized job tracker that allows you know which job is
                which. Track applications, interviews, and never miss a deadline
                again. Get ready to land your dream job effortlessly. Stay
                organized!
              </p>
              <BtnsWrapper>
                <button onClick={() => navigate("/register")}>
                  Login/Register
                </button>
                <button onClick={() => navigate("/all-post-jobs")}>
                  View <span>Available</span> Jobs
                </button>
              </BtnsWrapper>
            </div>
            <div className="landing__img">
              <img src={staticImage} alt="Job" />
            </div>
          </section>
        </summary>
      </div>
    </LandingWrapper>
  );
};

export default LandingPage;

const BtnsWrapper = styled.div`
  /* border: 2px solid red; */
  display: flex;
  gap: 10px;

  > button {
    padding: 6px 10px;
    border: 2px solid var(--dark);
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
  }

  > button:first-child {
    background-color: var(--dark);
    color: #fff;
  }

  > button:last-child {
    background-color: inherit;
    color: var(--dark);
    border: 2px solid var(--dark);
    font-weight: 600;
  }
  > button:hover {
    transform: scale(1.02);
  }

  @media screen and (max-width: 540px) {
    > button {
      font-size: 14px;
    }

    > button:last-child > span {
      display: none;
    }
  }
`;
